// @flow
import { asyncPaymentRedirectToOrderPage } from '../../duck';

import type { Node } from 'react';
import type { ImplementationType, PaymentImpl } from '../index';
import type { Order } from '../../../../../entities';
import type { RootState } from '../../../../index';
import type {BillingAddressReq} from '../../api';

export default class ManualTransferSolesPayment implements PaymentImpl {
  type: ImplementationType = 'manual_transfer_soles';
  order: Order;
  dispatch: Function;

  setUpPayment(order: Order, dispatch: Function, rootState: RootState) {
    this.order = order;
    this.dispatch = dispatch;
  }

  generateCustomUI = (): Node => undefined;

  executeUIAction(billingAddress: BillingAddressReq, rootState: RootState) {
    const order = rootState.newOrder.checkoutStep.order;

    this.dispatch(asyncPaymentRedirectToOrderPage(order));
  };

  showPopUp = (data: string) => undefined;

  clean = () => undefined;
}



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/PaymentImpl/ManualTransferSoles/index.js